import { combineReducers } from "redux";

import { plan } from "./plan/plan.reducers";
import { main } from "./main/main.reducers";

export const subscription = combineReducers({
    plan,
    main
});